import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type FormSettingsState = {
  nonWhistleblowingMessage: string;
  showNonWhistleblowingMessage: boolean;
};

const initialState: FormSettingsState = {
  nonWhistleblowingMessage: '',
  showNonWhistleblowingMessage: false,
};

const formSettingsSlice = createSlice({
  name: 'formSettings',
  initialState,
  reducers: {
    setShowNonWhistleblowingMessage: (state, action: PayloadAction<boolean>) => {
      state.showNonWhistleblowingMessage = action.payload;
    },
    setNonWhistleblowingMessage: (state, action: PayloadAction<string>) => {
      state.nonWhistleblowingMessage = action.payload;
    },
  },
});

export const {
  setShowNonWhistleblowingMessage,
  setNonWhistleblowingMessage,

} = formSettingsSlice.actions;

export default formSettingsSlice.reducer;
